import {
  Button,
  Buttons,
  Flex,
  Modal,
  ModalBody,
  ModalHeader,
  ModalHeaderProgress,
  ModalProps,
  ModalTitle,
  Text,
} from '@bitrise/bitkit';
import Markdown from 'markdown-to-jsx';
import React, { FunctionComponent, useEffect, useState } from 'react';

import termsOfService from '../../../../TERMS_OF_SERVICE.md';

import './TermsOfServiceModal.css';

interface Props extends ModalProps {
  onAccept: () => void;
  onDecline: () => void;
}

const TermsOfServiceModal: FunctionComponent<Props> = (props) => {
  const { onAccept, onDecline, ...rest } = props;
  const [scrollProgress, setScrollProgress] = useState(0);
  const [scrollNode, setScrollNode] = useState<HTMLElement>();

  useEffect(() => {
    setScrollProgress(0);

    if (scrollNode) {
      scrollNode.addEventListener('scroll', () => {
        if (scrollNode) {
          setScrollProgress(
            scrollNode.scrollTop / (scrollNode.scrollHeight - scrollNode.offsetHeight),
          );
        }
      });
    }
  }, [scrollNode]);

  return (
    <Modal {...rest} fullHeight>
      <ModalHeader withSeparator>
        <Flex>
          <ModalTitle>Trace Terms of Service</ModalTitle>
        </Flex>
        <ModalHeaderProgress progress={scrollProgress} />
      </ModalHeader>

      <ModalBody direction="vertical" initial="none" paddingVertical="x0">
        <Flex
          className="TermsOfService__container"
          container
          direction="vertical"
          grow
          initial="none"
        >
          <Flex grow initial="none" innerRef={setScrollNode} overflow="scroll">
            <Text config="8">
              <Markdown className="TermsOfService__content">{termsOfService}</Markdown>
            </Text>
          </Flex>
        </Flex>

        <Buttons alignChildrenHorizontal="middle" paddingVertical="x10">
          <Button level="secondary" onClick={onDecline}>
            Decline
          </Button>

          <Button level="primary" onClick={onAccept}>
            Accept
          </Button>
        </Buttons>
      </ModalBody>
    </Modal>
  );
};

export default TermsOfServiceModal;
